<!--
 * @Description: 电子面单 宝付绑卡成功 回调
 * @Author: muqingkun
 * @Date: 2022-11-11 14:16:41
 * @LastEditTime: 2022-11-11 14:58:31
 * @LastEditors: muqingkun
 * @Reference:
-->
<template>
  <div class="hint">
    <div class="hint-box">
      <img src="@/assets/img/success.png" alt="" srcset="" width="100px">
      <h3>签约成功</h3>
      <p>请回到JMS继续操作</p>
    </div>
  </div>
</template>
<script>
export default {
  name: 'BfCallback',
}
</script>
<style>
.hint {
  text-align: center;
  position: fixed;
  width: 100%;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
}
.hint .hint-box {
  font-size: 24px;
  width: 90%;
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  height: 200px;
  margin: auto;
}
.hint .hint-box h3 {
  margin: 20px 0 10px;
  font-weight: 700;
}
.hint .hint-box p {
  font-size: 16px;
}
</style>

